import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { Image } from '../../atoms';

type OverlayProps = {
  children?: ReactNode;
  height: number;
  image: string;
  positionImage?: string;
};

const StyledOverlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
`;

const Overlay = ({ children, image, height, positionImage }: OverlayProps) => {
  return (
    <div style={{ position: 'relative' }}>
      <Image src={image} height={height} position={positionImage} />
      <StyledOverlay />
      {/* {children} */}
    </div>
  );
};

export default Overlay;
